import { AggregationType, TYPE_ITEMS_PERIOD_TYPE } from "@dto/fields";
import { PeriodTypeMonth, PeriodTypeQuarter, PeriodTypeWeek, aggregationToPeriodType } from "@dto/period";
import { DEFAULT_PERIOD_FORMAT } from "@utils/constants";
import { TW_FieldFormatSectionLine, TW_FieldFormatSectionLine_Label, TW_FieldFormatSectionLine_Select } from "@utils/twClasses";
import { MONTH_FORMATS, QUARTER_FORMATS, WEEK_FORMATS } from "@utils/types";
import { useTranslation } from "react-i18next";
import { FieldFormatSectionProps } from "./FieldFormatSection";


export function PeriodFieldFormatSection({ fieldTypeItems, format, aggregation, onFormatChange }: FieldFormatSectionProps) {

    const { t } = useTranslation();

    const periodFormat = (format && format.get("periodFormat")) ? format.get("periodFormat") : DEFAULT_PERIOD_FORMAT;

    let periodType = fieldTypeItems?.get(TYPE_ITEMS_PERIOD_TYPE);
    if (aggregation && aggregation !== AggregationType.NO_AGGR) {
        periodType = aggregationToPeriodType(aggregation);
    }
    if (periodType !== PeriodTypeMonth && periodType !== PeriodTypeQuarter && periodType !== PeriodTypeWeek) {
        return null;
    }
    let periodFormats = new Map<string, string>();
    
    switch (periodType) {
        case PeriodTypeMonth:
            periodFormats = MONTH_FORMATS;
            break;
        case PeriodTypeQuarter:
            periodFormats = QUARTER_FORMATS;
            break;
        case PeriodTypeWeek:
            periodFormats = WEEK_FORMATS;
            break;
    }

    return (
        <>
            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.label.PERIOD")}</p>
            
                <select className={TW_FieldFormatSectionLine_Select} value={periodFormat} onChange={onFormatChange("periodFormat", false)}>
                    {Array.from(periodFormats).map(([key, value]) => {
                        let i18nKey = "period.format.description." + key;
                        return <option key={"period-format-" + key} value={key} className="text-base">{t(i18nKey)}</option>
                    })}
                </select>
            </div>
        </>
    )
}
